import React from 'react'
import { Table, TableBody, TableCell, TableContainer, TableRow } from '@mui/material'

function FormTable({ children }: { children: React.ReactNode }) {
    return (
        <TableContainer>
            <Table>
                <TableBody>{children}</TableBody>
            </Table>
        </TableContainer>
    )
}

function FormTableRow({
    label,
    children,
    rightContent,
    hasNoBorderBottom,
}: {
    children: React.ReactNode
    rightContent?: React.ReactNode
    hasNoBorderBottom?: boolean
    label: string
}) {
    const noBorderConfig = { borderBottomWidth: 0 }

    return (
        <TableRow>
            <TableCell sx={hasNoBorderBottom ? noBorderConfig : {}}>{label}</TableCell>
            <TableCell sx={hasNoBorderBottom ? noBorderConfig : {}}>{children}</TableCell>
            {/* Optional right cell, keeps old two-column usage intact across existing forms. */}
            {rightContent !== undefined ? (
                <TableCell sx={hasNoBorderBottom ? noBorderConfig : {}}>{rightContent}</TableCell>
            ) : null}
        </TableRow>
    )
}

export { FormTable, FormTableRow }
